export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
  featured?: boolean;
}

export const articles: Article[] = [
  {
    slug: 'getting-started',
    title: '91免费版新手指南：快速上手完整教程',
    excerpt: '刚接触91免费版不知道从哪里开始？这篇新手指南将从下载安装到功能使用，手把手带你快速掌握91免费版的全部核心功能。',
    content: `<h2>什么是91免费版？</h2><p>91免费版是一个集成了海量免费软件资源的综合平台，覆盖系统工具、办公软件、多媒体、安全防护、网络工具、开发工具、设计工具和生活娱乐等八大类别。平台所有软件均经过安全检测，确保用户下载的每一款软件都纯净无毒。</p><h2>如何开始使用？</h2><p>访问91免费版官网，在首页即可看到热门推荐软件和最新上线的工具。您可以直接在搜索框中输入软件名称查找，也可以按照分类浏览感兴趣的工具。</p><h2>下载与安装</h2><p>找到目标软件后，点击"免费下载"按钮即可开始下载。下载完成后，双击安装包按照提示完成安装。所有软件均提供详细的安装教程，即使是电脑新手也能轻松完成。</p><h2>核心功能一览</h2><p>91免费版提供以下核心功能：海量免费软件库、分类精准导航、详细使用教程、用户真实评价、软件版本更新提醒。所有功能完全免费，无需注册付费。</p>`,
    category: '使用指南',
    categorySlug: 'system-tools',
    author: '91免费版编辑部',
    publishDate: '2026-07-28',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20beginner%20guide%2C%20minimalist%20design%20with%20abstract%20geometric%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style%2C%20professional%20tech%20blog%20imagery&width=600&height=400&seq=article-getting-started&orientation=landscape',
    tags: ['91免费版教程', '新手入门', '使用指南', '免费软件'],
    featured: true,
  },
  {
    slug: 'install-guide',
    title: '91免费版安装教程：三步完成安全安装',
    excerpt: '详细的91免费版安装步骤指南，从下载到完成的每一步都有图文说明，确保您安全顺利地完成软件安装。',
    content: `<h2>安装前准备</h2><p>在安装91免费版之前，请确保您的电脑满足最低系统要求：Windows 7及以上系统、2GB以上内存、500MB可用磁盘空间。建议关闭杀毒软件以避免误报。</p><h2>第一步：下载安装包</h2><p>访问91免费版官方网站，点击首页的"立即免费下载"按钮。根据您的操作系统版本选择对应的安装包。下载完成后，找到下载的安装文件。</p><h2>第二步：运行安装程序</h2><p>双击安装包文件，在弹出的安全提示中选择"是"或"运行"。安装向导会自动启动，选择安装路径后点击"下一步"。建议使用默认安装路径。</p><h2>第三步：完成安装</h2><p>等待安装进度条完成，勾选"创建桌面快捷方式"以便日后快速启动。点击"完成"按钮，91免费版即可正常使用。</p>`,
    category: '安装教程',
    categorySlug: 'system-tools',
    author: '91免费版技术团队',
    publishDate: '2026-07-25',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20software%20installation%20tutorial%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-install-guide&orientation=landscape',
    tags: ['91免费版安装', '安装教程', '下载指南'],
  },
  {
    slug: 'features-intro',
    title: '91免费版功能介绍：八大核心功能深度解析',
    excerpt: '全面了解91免费版的核心功能特性，包括智能分类、安全检测、版本管理、用户社区等八大功能的详细介绍。',
    content: `<h2>功能一：智能分类导航</h2><p>91免费版将海量软件按照使用场景分为八大类别，用户可以通过分类快速找到所需软件。每个分类下还有更细致的子分类，确保精准匹配用户需求。</p><h2>功能二：安全检测机制</h2><p>所有上架软件均经过多重安全检测流程，包括病毒扫描、恶意行为检测、捆绑软件筛查等，确保用户下载的每一款软件都安全可靠。</p><h2>功能三：版本追踪更新</h2><p>91免费版实时追踪各软件的最新版本动态，第一时间为用户推送更新提醒，确保用户始终使用最新、最稳定的版本。</p><h2>功能四：详细使用教程</h2><p>每款软件都配有详细的使用教程和常见问题解答，帮助用户快速上手使用，解决使用过程中遇到的各种问题。</p><h2>功能五：用户评价体系</h2><p>用户可以对使用过的软件进行评分和评论，帮助其他用户了解软件的真实使用体验，形成良性的社区互动。</p><h2>功能六：一键下载安装</h2><p>优化下载链路，支持多线程加速下载，大幅缩短下载等待时间。安装过程简单明了，无需复杂配置。</p><h2>功能七：个性化推荐</h2><p>基于用户的浏览和下载历史，智能推荐可能感兴趣的软件，帮助用户发现更多优质工具。</p><h2>功能八：多平台支持</h2><p>91免费版覆盖Windows、macOS、Linux三大主流桌面操作系统，用户可以根据自己的设备选择对应的版本。</p>`,
    category: '功能介绍',
    categorySlug: 'system-tools',
    author: '91免费版产品团队',
    publishDate: '2026-07-20',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20software%20features%20introduction%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-features-intro&orientation=landscape',
    tags: ['91免费版功能', '软件推荐', '功能介绍'],
    featured: true,
  },
  {
    slug: 'faq',
    title: '91免费版常见问题解答（FAQ）',
    excerpt: '收集整理了用户最常问的20个问题，涵盖下载、安装、使用、安全等各个方面，帮您快速解决疑惑。',
    content: `<h2>下载相关</h2><p><strong>Q: 91免费版真的完全免费吗？</strong><br/>A: 是的，91免费版平台上的所有软件均为免费软件，用户无需支付任何费用即可下载使用。</p><p><strong>Q: 下载速度慢怎么办？</strong><br/>A: 可以尝试切换下载节点，或使用下载管理器进行下载。</p><h2>安装相关</h2><p><strong>Q: 安装时提示有病毒怎么办？</strong><br/>A: 这是杀毒软件的误报，请放心。建议临时关闭杀毒软件后重新安装。</p><h2>使用相关</h2><p><strong>Q: 如何更新已安装的软件？</strong><br/>A: 打开91免费版客户端，在"我的软件"页面可以查看所有已安装软件的更新状态，一键升级。</p>`,
    category: '帮助中心',
    categorySlug: 'system-tools',
    author: '91免费版客服团队',
    publishDate: '2026-07-15',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20FAQ%20help%20center%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-faq&orientation=landscape',
    tags: ['91免费版FAQ', '常见问题', '帮助中心'],
    featured: true,
  },
  {
    slug: 'best-free-tools-2026',
    title: '2026年最值得推荐的10款免费效率工具',
    excerpt: '精选2026年最实用的10款免费效率工具，涵盖笔记、任务管理、时间追踪、文件管理等多个领域。',
    content: `<h2>为何选择免费效率工具？</h2><p>在数字化办公时代，高效的工具能显著提升工作效率。然而许多专业工具价格不菲，对于个人用户和初创团队来说是一笔不小的开支。本文将推荐10款完全免费且功能强大的效率工具。</p><h2>1. Notion - 全能工作空间</h2><p>Notion将笔记、任务管理、数据库和维基融为一体，免费版已足够满足个人使用需求。无论是做读书笔记还是项目规划，Notion都能胜任。</p><h2>2. Obsidian - 第二大脑</h2><p>Obsidian是一款本地优先的Markdown笔记软件，通过双向链接构建知识网络，帮助你建立"第二大脑"。所有数据存储在本地，隐私安全有保障。</p><h2>3. Trello - 看板管理</h2><p>Trello采用直观的看板方式进行项目管理，拖拽操作简单直观，免费版支持10个看板，适合个人和小团队使用。</p>`,
    category: '软件推荐',
    categorySlug: 'office-software',
    author: '91免费版编辑部',
    publishDate: '2026-07-10',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20best%20free%20productivity%20tools%20recommendation%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-best-tools-2026&orientation=landscape',
    tags: ['免费工具推荐', '效率工具', '2026推荐'],
    featured: true,
  },
  {
    slug: 'system-optimization-guide',
    title: '电脑变慢怎么办？系统优化完整指南',
    excerpt: '电脑使用时间长了越来越慢？这份系统优化指南教您使用免费工具清理垃圾、优化启动项、整理磁盘。',
    content: `<h2>电脑变慢的常见原因</h2><p>电脑使用一段时间后变慢是常见现象，主要原因包括：启动项过多、磁盘碎片积累、临时文件堆积、后台程序过多、硬件老化等。</p><h2>使用CCleaner清理系统</h2><p>CCleaner是最知名的免费系统清理工具。打开CCleaner，点击"分析"扫描系统中的垃圾文件，然后点击"清理"即可释放大量磁盘空间。建议每周清理一次。</p><h2>管理开机启动项</h2><p>过多的开机启动项是拖慢系统启动速度的主要原因。在CCleaner的"工具"-"启动"中，可以禁用不必要的启动项，显著提升开机速度。</p>`,
    category: '使用教程',
    categorySlug: 'system-tools',
    author: '91免费版技术团队',
    publishDate: '2026-07-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20computer%20system%20optimization%20guide%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-system-optimization&orientation=landscape',
    tags: ['系统优化', '电脑加速', 'CCleaner教程'],
  },
  {
    slug: 'office-software-comparison',
    title: '三大免费办公套件详细对比：哪个更适合你？',
    excerpt: 'LibreOffice、WPS Office免费版、Google Docs三大免费办公套件全方位对比，帮你选择最适合的工具。',
    content: `<h2>对比概览</h2><p>对于不需要购买Microsoft Office的用户来说，LibreOffice、WPS Office免费版和Google Docs是最主流的三个选择。本文将从功能完整性、兼容性、界面体验、协作能力等方面进行详细对比。</p><h2>LibreOffice - 开源首选</h2><p>LibreOffice是开源的免费办公套件，包含Writer（文字处理）、Calc（电子表格）、Impress（演示文稿）等完整组件。优势是完全免费无广告，劣势是界面相对传统。</p><h2>WPS Office 免费版 - 国产精品</h2><p>WPS Office界面美观现代，兼容性极佳，几乎完美兼容Microsoft Office格式。免费版含少量广告。对于大多数中文用户来说是最佳选择。</p><h2>Google Docs - 云端协作</h2><p>Google Docs完全基于云端，实时协作功能强大。适合需要多人同时编辑文档的场景。劣势是需要网络连接，离线功能有限。</p>`,
    category: '软件对比',
    categorySlug: 'office-software',
    author: '91免费版编辑部',
    publishDate: '2026-06-28',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20office%20software%20comparison%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-office-comparison&orientation=landscape',
    tags: ['办公软件对比', 'LibreOffice', 'WPS Office', 'Google Docs'],
  },
  {
    slug: 'video-editing-free-tools',
    title: '零成本视频剪辑：5款免费视频编辑软件横评',
    excerpt: '不需要付费的Premiere Pro也能做出精彩视频！评测5款免费视频编辑软件，从入门到专业全覆盖。',
    content: `<h2>免费视频剪辑也能很专业</h2><p>很多人认为视频剪辑必须购买昂贵的专业软件，其实市面上有不少优秀的免费视频编辑工具。本文精选5款进行详细评测。</p><h2>DaVinci Resolve - 专业首选</h2><p>DaVinci Resolve是好莱坞级调色软件的免费版，功能极其强大。支持多轨道编辑、专业调色、Fairlight音频后期和Fusion视觉特效。唯一的缺点是对电脑配置要求较高。</p><h2>Shotcut - 开源跨平台</h2><p>Shotcut是一款开源的跨平台视频编辑器，支持广泛的视频格式，时间线编辑灵活。界面简洁，学习曲线平缓。</p>`,
    category: '软件推荐',
    categorySlug: 'multimedia',
    author: '91免费版编辑部',
    publishDate: '2026-06-20',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20technology%20blog%20illustration%20for%20free%20video%20editing%20software%20review%2C%20minimalist%20design%20with%20abstract%20shapes%2C%20warm%20orange%20and%20teal%20color%20accents%20on%20light%20cream%20background%2C%20editorial%20digital%20art%20style&width=600&height=400&seq=article-video-editing&orientation=landscape',
    tags: ['免费视频剪辑', 'DaVinci Resolve', '视频编辑软件'],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured).slice(0, 4);
}

export function getRelatedArticles(currentSlug: string, limit = 3): Article[] {
  return articles.filter((a) => a.slug !== currentSlug).slice(0, limit);
}

export function getCategoryName(slug: string): string {
  const names: Record<string, string> = {
    'system-tools': '系统工具',
    'office-software': '办公软件',
    'multimedia': '多媒体工具',
    'security': '安全防护',
    'network-tools': '网络工具',
    'dev-tools': '开发工具',
    'design-tools': '设计工具',
    'lifestyle': '生活娱乐',
  };
  return names[slug] || slug;
}